import React, { useEffect } from 'react'

import {
  HeadingLarge,
  LayoutContainer as Container,
  Loader,
  TabToggle,
  Label,
  HeadingSmall,
} from '@pb/components'
import { Breakpoints, useMediaQuery } from '@pb/utils'
import { useDispatch, useSelector } from 'react-redux'

import appSelectors from 'App/duck/selectors'
import optimizelyConstants from 'constants/optimizely'
import { ACCOUNT_TRACKING_EVENTS } from 'features/account/constants'
import getAccountTracking from 'features/account/helpers/getAccountTracking'
import useOptimizelyToggle from 'features/account/hooks/useOptimizelyToggle'
import MyAccountLayout from 'features/account/MyAccountLayout'
import useKlarnaPostPurchase from 'features/klarna/hooks/useKlarnaPostPurchase'

import { ALL_TAB, TODO_TAB } from '../../constants'
import { operationRunKlarnaOrderOperation, operationSetSelectedTab } from '../../duck/operations'
import selectors from '../../duck/selectors'
import AllPurchases from '../AllPurchases'
import Todo from '../Todo'
import styles from './HMPayOverview.scss'

const HMPayComponent: React.FC = () => {
  const dispatch = useDispatch()
  const [klarnaScriptLoaded, klarnaScriptError] = useKlarnaPostPurchase()
  const appState = useSelector((state) => state)
  const { trackViewEvent } = getAccountTracking(appState)
  const trackPageView = trackViewEvent(ACCOUNT_TRACKING_EVENTS.purchasesKlarnaPageView.id)
  const isLoading = useSelector(selectors.getIsLoading)
  const isPostPurchaseEnabled = useSelector(appSelectors.getIsPayLaterPostPurchaseEnabled)
  const selectedTab = useSelector(selectors.getSelectedTab)
  const setSelectedTab = (tab: string): void => {
    dispatch(operationSetSelectedTab(tab))
  }
  const shouldShowManageCardButton = useSelector(selectors.getShouldShowManageCardButton)
  const manageCardOperation = useSelector(selectors.getManageCardOperation)

  const runKlarnaOrderOp = (token: string, orderId: string): void => {
    dispatch(operationRunKlarnaOrderOperation(token, orderId))
  }

  const isStaticUserMenuEnabled = useOptimizelyToggle({
    key: optimizelyConstants.ACCOUNT_STATIC_MENU_ENABLE,
    internalToggle: 'static_menu_internal_toggle',
  })
  const XLargeBreakpoint = useMediaQuery(Breakpoints.XLARGE)

  useEffect(() => {
    trackPageView()
  }, [])

  const shouldNotShowStaticMenu = XLargeBreakpoint || !isStaticUserMenuEnabled

  return isLoading || (!klarnaScriptLoaded && !klarnaScriptError) ? (
    <Loader />
  ) : (
    <Container large={!shouldNotShowStaticMenu}>
      <MyAccountLayout isDisabled={shouldNotShowStaticMenu}>
        <HeadingLarge className={styles.heading}>
          <Label copyKey="account.klarna.link" />
        </HeadingLarge>
        {isPostPurchaseEnabled ? (
          <TabToggle
            tabs={[
              {
                id: TODO_TAB.id,
                heading: <Label copyKey={TODO_TAB.text} />,
                children: (
                  <Todo
                    manageCardOperation={manageCardOperation}
                    runKlarnaOp={runKlarnaOrderOp}
                    shouldShowManageCardButton={shouldShowManageCardButton}
                  />
                ),
              },
              {
                id: ALL_TAB.id,
                heading: <Label copyKey={ALL_TAB.text} />,
                children: <AllPurchases runKlarnaOp={runKlarnaOrderOp} />,
              },
            ]}
            setSelectedTab={setSelectedTab}
            defaultOpenTab={selectedTab}
          />
        ) : (
          <HeadingSmall center className={styles.comingSoonHeader}>
            <Label copyKey="coming.soon.add.to.cart" />
          </HeadingSmall>
        )}
      </MyAccountLayout>
    </Container>
  )
}

export default HMPayComponent
